import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isTokenValid, clearSession } from '../services/jwtHelper';
import { usuarioEhContador, ROTA_CONTADOR } from '../utils/perfilContador';

// Autenticação do login para rotas privadas
const safeParseIsLogged = () => {
  try {
    return JSON.parse(localStorage.getItem("isLogged")) === true;
  } catch {
    return false;
  }
};

export const Private = ({children}) => {
  const location = useLocation();
  const token = localStorage.getItem("sessionToken");
  const isLogged = safeParseIsLogged();

  // Verificar se está logado e se o token é válido
  if (!isLogged || !token || !isTokenValid(token)){
    // Logar motivo para diagnostico
    if (!isLogged) console.error('[PRIVATE_ROUTE] Logout: isLogged = false');
    if (!token) console.error('[PRIVATE_ROUTE] Logout: sem token no localStorage');
    if (token && !isTokenValid(token)) console.error('[PRIVATE_ROUTE] Logout: token invalido');
    console.error('[PRIVATE_ROUTE] Redirecionando para login. Path:', window.location.pathname);
    // Limpar sessão se token inválido ou expirado
    clearSession();
    return <Navigate to="/" />
  }
  // Contador (perfil restrito) so usa a revisao tributaria: qualquer outra tela
  // chamaria rotas que o backend recusa (Middleware.PerfilRestrito).
  if (usuarioEhContador() && location.pathname !== ROTA_CONTADOR) {
    return <Navigate to={ROTA_CONTADOR} replace />
  }
  return children
}

Private.propTypes = {
  children: PropTypes.node.isRequired,
};

export const PrivateLogin = ({children}) => {
  const token = localStorage.getItem("sessionToken");
  const isLogged = safeParseIsLogged();

  // Se está logado e token válido, redirecionar para dashboard
  if (isLogged && token && isTokenValid(token)){
    return <Navigate to="/inicio/dashboard" />
  }
  return children
}

PrivateLogin.propTypes = {
  children: PropTypes.node.isRequired,
};
